export default __webpack_public_path__ + "c0ed805bca30968d9f91b8e3ef767dea.png";